// Filter options for the work-order lists (ADO-7600 G-49): POST api/v3/pro/config { config_slugs[] }
// → { <slug>: { title, slug, key, options:[{title, value, trade_id?}], value, is_multiple, sort, field_type,
//      type?, format?, depends_on? } }. `key` (= `slug`) is the list param the selection goes back in.
// Slugs per page: Laravel ai/ADO-7600/doc/api-graph.md §3, work-order-filters.md.
import { apiCall } from "./apiCall";

export const LIST_CONFIG_SLUGS = {
  appointment: ["date_range", "appointment_date_types", "appointment_statuses", "appointment_job_types", "trades", "services", "partner_job"],
  sar: ["date_range", "sar_date_types", "sar_statuses", "services", "sar_payment_status", "partner_job"],
  rq: ["date_range", "rq_date_types", "rq_statuses", "rq_system_types", "amount_min", "amount_max", "partner_job"],
  uq: ["date_range", "uq_date_types", "uq_statuses", "trades", "uq_job_types", "uq_sources", "amount_min", "amount_max", "partner_job"],
};

const FIELD_TYPES = ["dropdown", "input", "date_range"];

function normalise(body) {
  const list = Array.isArray(body) ? body : Object.values(body || {});
  return list
    .filter((f) => f && FIELD_TYPES.includes(f.field_type))
    .map((f) => ({
      key: f.key || f.slug,
      title: f.title || f.key || f.slug,
      fieldType: f.field_type,
      isMultiple: f.is_multiple == 1,
      inputType: f.type || "text",
      dependsOn: f.depends_on || null,
      options: (f.options || []).map((o) => ({
        value: String(o.value),
        label: o.title ?? String(o.value),
        tradeId: o.trade_id != null ? String(o.trade_id) : null,
      })),
      sort: Number(f.sort) || 0,
    }))
    .filter((f) => f.key)
    .sort((a, b) => a.sort - b.sort);
}

const cache = {};

export const listFilterApi = {
  // { ok, filters } — cached per list for the session
  async config(list) {
    const slugs = LIST_CONFIG_SLUGS[list];
    if (!slugs) return { ok: false, filters: [] };
    if (cache[list]) return { ok: true, filters: cache[list] };
    const res = await apiCall("post", "config", { config_slugs: slugs }, { silent: true });
    if (!res.ok) return { ok: false, filters: [], message: res.message };
    cache[list] = normalise(res.body);
    return { ok: true, filters: cache[list] };
  },
};
